<template>
  <div class="fixed-banner">
    <div class="container-fluid banner">
      <div class="row">
        <div class="col-8 shop-title">
          <span class="title-text">{{ store.Name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopHeader",
  props: {
    storeId: {
      type: String,
      default: "2016949"
    }
  },
  data() {
    return {
      store: Object
    };
  }
};
</script>

